module.exports = __webpack_public_path__ + "assets/img/no_img_b.ea185909.png";